<div class="card panel-flat-color primary-panel">
    <div class="panel-flat-header">
        <h3>Ryan Contacts</h3>
    </div>
    <div class="panel-flat-body" [formGroup]="form()">
        <div class="referral-contacts-grid">
            <label class="referral-field-label">Client Principal</label>
            <referral-input-with-revert
                formControlName="ryanContactCPName"
                [systemValue]="systemReferral()?.ryanContactCPName"
                [originalValue]="originalReferral()?.ryanContactCPName"
                [maxlength]="255"
            />
            <label class="referral-field-label">Engagement Principal</label>
            <referral-input-with-revert
                formControlName="ryanContactEPName"
                [systemValue]="systemReferral()?.ryanContactEPName"
                [originalValue]="originalReferral()?.ryanContactEPName"
                [maxlength]="255"
            />
            <label class="referral-field-label">Account Handler</label>
            <div>{{ referral()?.ryanContactAHName }}</div>
            <label class="referral-field-label">Appeal Assigned User</label>
            <referral-input-with-revert
                formControlName="ryanContactJSUserID"
                [systemValue]="systemReferral()?.ryanContactJSUserID"
                [originalValue]="originalReferral()?.ryanContactJSUserID"
                [isUserPicker]="true"
                [userDisplayValue]="form().get('ryanContactJSName')?.value"
                [systemUserDisplayValue]="systemReferral()?.ryanContactJSName"
                [originalUserDisplayValue]="originalReferral()?.ryanContactJSName"
                (userDisplayValueChange)="updateAppealAssignedUserName($event)"
            />
            <label class="referral-field-label">User Submitting</label>
            <div>{{ referral()?.ryanContactSubmitterName }}</div>
        </div>
    </div>
</div>
